export default function Auth({next, router}) {
    if (!localStorage.getItem('token') || !localStorage.getItem('new-auth')) {
        return router.push({ name: 'login' });
    }

    let role = localStorage.getItem('role');
    if (!role || role != 1) {
        return router.push({ name: 'login' });
    }

    return next();
}



// WEBPACK FOOTER //
// ./src/middleware/Auth.js